
export const CREATE_BILL_INVOICE_REQUEST = "CREATE_BILL_INVOICE_REQUEST";
export const CREATE_BILL_INVOICE_SUCCESS = "CREATE_BILL_INVOICE_SUCCESS";
export const CREATE_BILL_INVOICE_FAIL = "CREATE_BILL_INVOICE_FAIL";
export const CREATE_BILL_INVOICE_RESET = "CREATE_BILL_INVOICE_RESET";



export const GET_BILL_INVOICE_REQUEST = "GET_BILL_INVOICE_REQUEST";
export const GET_BILL_INVOICE_SUCCESS = "GET_BILL_INVOICE_SUCCESS";
export const GET_BILL_INVOICE_FAIL = "GET_BILL_INVOICE_FAIL";
export const GET_BILL_INVOICE_RESET = "GET_BILL_INVOICE_RESET";


export const GENERATE_BILL_INVOICE_PDF_GENERATION_REQUEST = "GENERATE_BILL_INVOICE_PDF_GENERATION_REQUEST";
export const GENERATE_BILL_INVOICE_PDF_GENERATION_SUCCESS = "GENERATE_BILL_INVOICE_PDF_GENERATION_SUCCESS";
export const GENERATE_BILL_INVOICE_PDF_GENERATION_FAIL = "GENERATE_BILL_INVOICE_PDF_GENERATION_FAIL";
export const GENERATE_BILL_INVOICE_PDF_GENERATION_RESET = "GENERATE_BILL_INVOICE_PDF_GENERATION_RESET";


export const PULL_JOB_STATUS_REQUEST = "PULL_JOB_STATUS_REQUEST";
export const PULL_JOB_STATUS_SUCCESS = "PULL_JOB_STATUS_SUCCESS";
export const PULL_JOB_STATUS_FAIL = "PULL_JOB_STATUS_FAIL";
export const PULL_JOB_STATUS_RESET = "PULL_JOB_STATUS_RESET";


export const TAKE_DASHBOARD_SCREENSHOT_REQUEST = 
  "TAKE_DASHBOARD_SCREENSHOT_REQUEST";
export const TAKE_DASHBOARD_SCREENSHOT_SUCCESS = 
  "TAKE_DASHBOARD_SCREENSHOT_SUCCESS";
export const TAKE_DASHBOARD_SCREENSHOT_FAIL = 
  "TAKE_DASHBOARD_SCREENSHOT_FAIL";
export const TAKE_DASHBOARD_SCREENSHOT_RESET = 
  "TAKE_DASHBOARD_SCREENSHOT_RESET";